import React, { useEffect, useState } from 'react';
import { Autocomplete, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, ListItem, ListItemText, TextField, Typography } from '@mui/material';
import { useFormik } from 'formik';
import * as yup from 'yup';
import Grid from '@mui/system/Unstable_Grid';
export function FimCotacaoDialog({ service, message, clienteId, onClose, ...props }) {
    const [value, setValue] = useState(null);
    const [options, setOptions] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [loading, setLoading] = useState(false);
    const validationSchema = yup.object().shape({
        documentoId: yup.string().required('Introduza o número da proposta')
    });
    useEffect(() => {
        let active = true;
        const fetchData = async () => {
            if (inputValue === '') {
                setOptions([]);
                return;
            }
            setLoading(true);
            try {
                let data = await service.lookupProposta(inputValue, clienteId);
                if (active) {
                    setOptions(data);
                }
            }
            catch (e) {
                console.error(e);
            }
            finally {
                if (active)
                    setLoading(false);
            }
        };
        fetchData();
        return () => {
            active = false;
        };
    }, [inputValue]);
    const form = useFormik({
        initialValues: {},
        validateOnChange: false,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            if (value && value.documento) {
                onClose(value.documento);
            }
            else {
                onClose();
            }
        }
    });
    return (<Dialog {...props} fullWidth maxWidth={'md'}>
      <DialogTitle>{props.title}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid xs={12}>
            <Typography>{message}</Typography>
          </Grid>
          <Grid xs={12} sx={{ mt: 1 }}>
            <Autocomplete value={value} // O valor completo da opção selecionada
     onChange={(event, newValue) => {
            setValue(newValue);
            form.setFieldValue('documentoId', newValue.id, true);
            form.setFieldTouched('documentoId', true);
        }} isOptionEqualToValue={(e, v) => {
            return e.id === v.id;
        }} inputValue={inputValue} onInputChange={(_, newInputValue) => setInputValue(newInputValue)} options={options} noOptionsText={inputValue === '' || inputValue.length < 2 ? 'Introduza um termo de pesquisa' : 'Nenhum documento encontrado'} loadingText={'A carregar dados do Primavera...'} getOptionLabel={option => option.documento} loading={loading} renderOption={(props, option) => (<ListItem {...props} key={option.id} dense>
                  <ListItemText primary={option.documento}/>
                </ListItem>)} renderInput={params => (<TextField {...params} name='documentoId' label='Documento' fullWidth onBlur={form.handleBlur} error={form.touched.documentoId && Boolean(form.errors.documentoId)} helperText={form.touched.documentoId && form.errors.documentoId} InputProps={{
                ...params.InputProps,
                endAdornment: (<>
                        {loading ? <CircularProgress color='inherit' size={20}/> : null}
                        {params.InputProps.endAdornment}
                      </>)
            }}/>)}/>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button type='button' onClick={() => onClose()}>
          Cancelar
        </Button>
        <Button disabled={!form.isValid || !form.dirty} onClick={() => {
            form.handleSubmit();
        }} variant='contained'>
          OK
        </Button>
      </DialogActions>
    </Dialog>);
}
